import { useContext, useMemo } from "react";

import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import GroupIdentityContext from "src/contexts/data/GroupIdentityContext";
import { createGroupSubMenu } from "src/routing/navigation";

/**
 * Registers the group submenu through the shared layout adapter.
 *
 * Postconditions: A rendered registration requests layout updates after render and removes its
 * submenu code on cleanup. Navigation factories retain responsibility for link metadata.
 * Missing required identities yield no registration. Identity references control recomputation.
 */
const GroupSubMenu: React.FC = () => {
    const { data: groupIdentity } = useContext(GroupIdentityContext);

    const subMenu = useMemo(
        () => {
            if (!groupIdentity) {
                return null;
            }

            return createGroupSubMenu(groupIdentity);
        },
        [groupIdentity]
    );

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default GroupSubMenu;
